const NumberHelpers = require("number_helpers");
const nFormatter = (num, digits) => {
  var si = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }

  let number = (num / si[i].value).toFixed(digits).replace(rx, "$1");
  // number = Math.round(number * 100) / 100;
  return number + si[i].symbol;
};

const insertInImgUrl = (imgurl, txt, n) => {
  let a = imgurl;
  let b = txt;
  let position = imgurl && imgurl.length - n;
  let output = [a && a.slice(0, position), b, a && a.slice(position)].join("");
  return output;
};
const changeInImgUrl = (imgurl, txt, patt) => {
  let output = imgurl && imgurl.replace(patt, txt);
  return output;
};
const numberWithCommas = (x) => {
  return x && x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
const chunkify = (a, n, size, balanced) => {
  if (n < 2) return [a];

  var len = a && a.length,
    out = [],
    i = 0;

  if (len % n === 0) {
    // size = Math.floor(len / n);
    while (i < len) {
      out.push(a.slice(i, (i += size)));
    }
  } else if (balanced) {
    while (i < len) {
      // size = Math.ceil((len - i) / n--);
      out.push(a.slice(i, (i += size)));
    }
  } else {
    n--;
    // size = Math.floor(len / n);
    if (len % size === 0) size--;
    while (i < size * n) {
      out.push(a.slice(i, (i += size)));
    }
    out.push(a.slice(size * n));
  }
  return out;
};

const randomnumber = (num) => {
  return Math.floor(Math.random() * num);
};

const timeDiffCalc = (dateFuture, dateNow) => {
  let diffInMilliSeconds = Math.abs(dateFuture - dateNow) / 1000;
  // calculate days
  const days = Math.floor(diffInMilliSeconds / 86400);
  diffInMilliSeconds -= days * 86400;

  // calculate hours
  const hours = Math.floor(diffInMilliSeconds / 3600) % 24;
  diffInMilliSeconds -= hours * 3600;

  // calculate minutes
  const minutes = Math.floor(diffInMilliSeconds / 60) % 60;
  diffInMilliSeconds -= minutes * 60;

  let difference = "";
  if (days > 0) {
    difference += days === 1 ? `${days} day, ` : `${days} days, `;
  }

  difference += hours === 0 || hours === 1 ? `${hours} hour, ` : `${hours} hours, `;

  difference += minutes === 0 || hours === 1 ? `${minutes} minutes` : `${minutes} minutes`;

  return difference;
};

const timeSince = (date) => {
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = seconds / 31536000;

  if (interval > 1) {
    return Math.round(interval) + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.round(interval) + " months";
  }

  interval = seconds / 604800;
  if (interval > 1) {
    return Math.round(interval) + " weeks";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.round(interval) + " days";
  }

  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }
  return Math.floor(seconds) + " seconds";
};
const timeDiffCalcRecomm = (pastDate, currentDate = new Date()) => {
  // To set two dates to two variables
  var date1 = new Date(pastDate);
  var date2 = new Date(currentDate);

  // To calculate the time difference of two dates
  var Difference_In_Time = date2.getTime() - date1.getTime();

  // To calculate the no. of days between two dates
  var Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));
  const beforeRoundoF = (Difference_In_Days / 365).toFixed(2);
  const afterRoundOf = Math.ceil(Difference_In_Days / 365);
  const diffInbeforeAfterRound = (afterRoundOf - beforeRoundoF).toFixed(2);
  const year = diffInbeforeAfterRound >= 0.3 ? parseInt(beforeRoundoF) : afterRoundOf;
  var yearObj = {
    year,
    beforeRoundoF,
    afterRoundOf,
    diffInbeforeAfterRound,
  };
  return yearObj;
};

const numberToHuman = (value) => {
  const modValue = NumberHelpers.number_to_human(value, {
    strip_insignificant_zeros: true,
    labels: { thousand: "K", million: "M", billion: "B", trillion: "T" },
    space_label: false,
  });
  if (modValue === "1,000K") {
    return "1M";
  }
  return modValue;
};
module.exports = {
  nFormatter,
  numberToHuman,
  chunkify,
  insertInImgUrl,
  changeInImgUrl,
  numberWithCommas,
  randomnumber,
  timeDiffCalc,
  timeDiffCalcRecomm,
  timeSince,
};
